import React, { useEffect, useState } from "react";
import { getMenu1, createDealerDiscount } from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";

const AllDiscountCreation = () => {
  const [menuData, setMenuData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const [form, setForm] = useState({
    category: "",
    subcategory: "",
    type: "",
    value: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  /* ------------------ FETCH MENU ------------------ */
  useEffect(() => {
    fetchMenu();
  }, []);

  const fetchMenu = async () => {
    try {
      const menuArray = await getMenu1();
      setMenuData(menuArray);
      setCategories(menuArray.map((item) => item.category));
    } catch (err) {
      console.error("Menu fetch failed", err);
    }
  };

  /* ------------------ CATEGORY CHANGE ------------------ */
  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;

    setForm({ ...form, category: selectedCategory, subcategory: "" });

    const categoryObj = menuData.find(
      (item) => item.category === selectedCategory
    );

    setSubcategories(categoryObj ? categoryObj.Subcategory : []);
  };

  /* ------------------ VALIDATION ------------------ */
  const validateForm = () => {
    const newErrors = {};

    if (!form.category) newErrors.category = "Category is required";
    if (!form.subcategory) newErrors.subcategory = "Subcategory is required";
    if (!form.type) newErrors.type = "Type is required";
    if (!form.value) newErrors.value = "Value is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ------------------ SUBMIT ------------------ */
  const handleSubmit = async () => {
    setSubmitted(true);

    if (!validateForm()) return;

    const payload = {
      category: form.category,
      subcategory: form.subcategory,
      type: form.type,
      value: form.value,
    };

    try {
      await createDealerDiscount(payload);
      showSnackbar("success", "Discount created successfully");

      setForm({
        category: "",
        subcategory: "",
        type: "",
        value: "",
      });

      setErrors({});
      setSubmitted(false);
    } catch (err) {
      showSnackbar("error", "Failed to create discount");
    }
  };

  return (  
    <div className="discount-container">
      <h3>Product Discount</h3>

      <div className="discount-row">
        {/* Category */}
        <div className="field">
          <label>Category:</label>
          <div className="input-wrapper">
            <select value={form.category} onChange={handleCategoryChange}>
              <option value="">Select Category</option>
              {categories.map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
            {submitted && errors.category && (
              <span className="error-text">{errors.category}</span>
            )}
          </div>
        </div>

        {/* Subcategory */}
        <div className="field">
          <label>Subcategory:</label>
          <div className="input-wrapper">
            <select
              value={form.subcategory}
              onChange={(e) =>
                setForm({ ...form, subcategory: e.target.value })
              }
            >
              <option value="">Select Subcategory</option>
              {subcategories.map((sub, i) => (
                <option key={i} value={sub.subcategory}>
                  {sub.subcategory}
                </option>
              ))}
            </select>
            {submitted && errors.subcategory && (
              <span className="error-text">{errors.subcategory}</span>
            )}
          </div>
        </div>

        {/* Type */}
        <div className="field">
          <label>Type:</label>
          <div className="input-wrapper">
            <select
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
            >
              <option value="">Select Type</option>
              <option value="discount">Discount</option>
              <option value="delardiscount">Dealer Discount</option>
              <option value="minorderqty">Min Order Qty</option>
              <option value="dealerminqty">Dealer Min Qty</option>
              <option value="active">Active</option>
            </select>
            {submitted && errors.type && (
              <span className="error-text">{errors.type}</span>
            )}
          </div>
        </div>

        {/* Value */}
        <div className="field">
          <label>Enter Value:</label>
          <div className="input-wrapper">
            <input
              type="number"
              value={form.value}
              onChange={(e) =>
                setForm({ ...form, value: e.target.value })
              }
            />
            {submitted && errors.value && (
              <span className="error-text">{errors.value}</span>
            )}
          </div>
        </div>

        <button onClick={handleSubmit}>Submit</button>
      </div>

      <style>{`
        .discount-container {
          background: #fff;
          padding: 20px 30px;
        }

        .discount-row {
          display: flex;
          align-items: flex-end;
          gap: 20px;
        }

        .field {
          display: flex;
          flex-direction: column;
        }

        label {
          font-size: 13px;
          margin-bottom: 6px;
        }

        select, input {
          width: 180px;
          height: 36px;
          padding: 6px 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .input-wrapper {
          position: relative;
          width: 180px;
        }

        .error-text {
          position: absolute;
          bottom: -16px;
          left: 0;
          font-size: 12px;
          color: red;
          white-space: nowrap;
        }

        button {
          height: 38px;
          padding: 0 18px;
          background: #0aa06e;
          color: #fff;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default AllDiscountCreation;
